import styled from 'styled-components';
import * as RubikMedium from '../fonts/Rubik-Medium.ttf';

export const NoExt = styled.div`
  height: auto;
  width: 690px;
  padding: 16px;
  color: white;
  font-family: 'Rubik';
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
  margin-left: 24px;
  border-radius: 6px;
  background: rgba(24,112,57,0.86);
`


export const Button = styled.div`
  font-family: Avenir;
  -webkit-appearance: none;
  background: linear-gradient( rgba(24,112,57,0.86), rgba(162,210,81,0.83));
  color: #ffffff;
  text-align: center;
  padding: 10px 14px;
  font-size: 16px;
  font-weight: bold;
  width: auto;
  border-radius: 5px;
  border: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  cursor: pointer;
  display: inline-block;
`

export const NextButton = styled(Button)`
  margin-right: 20px;

  ${props => !props.nextActive &&`
    display: none;
  `}

`

export const BackButton = styled(Button)`
  margin-right: 20px;
  background: #ffffff;
  color: gray;
  ${props => !props.backActive &&`
    display: none;
  `}
`

export const StartButton = styled(Button)`
  margin-left: 50px;
`

export const ResetButton = styled(Button)`
  background: #ffffff;
  color: gray;
`
